import React from 'react';
import './Template.scss';
import Button from '../../../Shared/Button/Button';
import If from '../../../Shared/If/If';
import img from 'src/assets/images/error-icon.svg';

const Template = ({
  image,
  backButton,
  hasPDF,
  header,
  msg,
  nextButton,
  nextDestination,
  onBackClick,
  onNextClick,
  textOffRamp,
  nextButtonID,
}) => {
  return (
    <div className="template-failure-modal">
      {<img className="template-img" src={image} alt="Icon" />}
      <div className="template-failure-heading e2e-failure-msg-header">
        {header}
      </div>
      <div className="template-message-container e2e-eVerify-try-again-button">
        <div className="template-failure-msg">{msg}</div>
        <If test={nextButton && !hasPDF}>
          <Button
            contextStyle={{
              display: 'block',
              margin: '0 auto',
              borderRadius: '2px',
              height: '60px',
              width: '296px',
              fontSize: '20px',
              padding: '0px',
            }}
            id={nextButtonID}
            buttonType="primary"
            onClick={onNextClick}
          >
            {nextButton}
          </Button>
        </If>
        <If test={hasPDF}>
          <a
            className="template-trp-pdf-link college-branded-primary-button"
            target="_blank"
            rel="noopener noreferrer"
            href={nextDestination}
          >
            {nextButton}
          </a>
        </If>
      </div>
      <If test={backButton && !hasPDF}>
        <div
          className="template-back-link e2e-trp-link college-branded-primary-button"
          onClick={onBackClick}
        >
          {backButton}
        </div>
      </If>
      <If test={textOffRamp}>
        <div className="template-text-off-ramp">
          {<a onClick={nextDestination}>{textOffRamp}</a>}
        </div>
      </If>
    </div>
  );
};

Template.defaultProps = {
  image: img,
  hasPDF: false,
  header: 'We are unable to verify your bank.',
  msg: 'The answers provided do not match the information we have on record. To continue, try signing in through your bank directly',
  //nextButton: 'Try Again',
  nextDestination: 'STEP_LANDING',
};

export default Template;
